export const AppTheme = {
    dark: {
        background: '#212529',
        color: 'white'
    },
    light: {
        background: 'white',
        color: 'black'
    },
    common: {
        transition: 'all 0.5s ease'
    }
}